import React from 'react';

import { Attribute } from 'types/Breaker';
import { AttributeMap } from 'hooks/useBreakerGallery';

import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';

import './Filters.scss';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import { CheckBox } from 'components/CheckBox/CheckBox';
import { FLAGS, useFlags } from 'hooks/useFlags';
import { TraitIcon } from 'utils/allsvg';

const traitId = (trait: string) => {
  return `trait-${trait.replace(/\s/g, '')}`;
};

const traitValueId = (value: string) => {
  return `trait-value-${value.replace(/\s/g, '')}`;
};

type Props = {
  activeFilters: Attribute[];
  attributeMap: AttributeMap;
  setFilter: (attribute: Attribute) => void;
  removeFilter: (attribute: Attribute) => void;
};

const Filters = ({ activeFilters, attributeMap, setFilter, removeFilter }: Props) => {
  const { isFlagEnabled } = useFlags();

  const isAttributeActive = (traitType: string, value: string) => {
    return activeFilters.some((filter) => {
      return filter.traitType === traitType && filter.value === value;
    });
  };

  return (
    <div className="offcanvas-container galleryFilters">
      <div className="offcanvas-header py-3 m-0">
        <h5 className="offcanvas-title" id="offcanvasLabel">
          Filters
        </h5>
        <button
          type="button"
          className="btn-close btn-close-white text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="accordion accordion-flush" id="traitFilter">
          <h3 className="filters-title d-none d-md-block">Filters</h3>
          {Object.keys(attributeMap).map((traitType) => {
            const values = Array.from(attributeMap[traitType]);
            return (
              <div key={traitType} className="accordion-item">
                <h3 className="accordion-header px-3 px-md-0">
                  <button
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${traitId(traitType)}`}
                    aria-controls={traitId(traitType)}
                    aria-expanded="false"
                  >
                    {!isFlagEnabled(FLAGS.newGallery) && <TraitIcon traitType={traitType} />}
                    <span>{traitType}</span>
                  </button>
                </h3>
                <div id={traitId(traitType)} className="accordion-collapse collapse">
                  <div className="accordion-body px-3 px-md-0">
                    <SimpleBar autoHide={false} forceVisible="y" style={{ maxHeight: '200px' }}>
                      {values.map((value) => {
                        if (traitType === 'Canon' && value === 'False') {
                          return null;
                        }

                        return (
                          <div key={traitValueId(value)}>
                            {!isFlagEnabled(FLAGS.newGallery) ? (
                              <CheckBox
                                id={traitValueId(value)}
                                checked={isAttributeActive(traitType, value)}
                                onChange={() => {
                                  if (isAttributeActive(traitType, value)) {
                                    removeFilter({ traitType, value });
                                  } else {
                                    setFilter({ traitType, value });
                                  }
                                }}
                                size={16}
                              >
                                <label className="form-check-label" htmlFor={traitValueId(value)}>
                                  {value}
                                </label>
                              </CheckBox>
                            ) : (
                              <input
                                id={traitValueId(value)}
                                className="form-check-input"
                                type="checkbox"
                                checked={isAttributeActive(traitType, value)}
                                onChange={() => {
                                  if (isAttributeActive(traitType, value)) {
                                    removeFilter({ traitType, value });
                                  } else {
                                    setFilter({ traitType, value });
                                  }
                                }}
                              ></input>
                            )}
                          </div>
                        );
                      })}
                    </SimpleBar>
                  </div>
                </div>
                <HorizontalDivider />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Filters;
